import {curry} from "ramda";

function assign(source, target){
	return target && Object.assign(target, source || {});
}

export default curry(assign);
